import axios from "axios";
import { toast } from "react-toastify";

import AuthService from "../../../services/auth.service";

import { sync } from "./sync";

const APP_URL = process.env.APP_URL;

export function deleteFasting({
  handleNotfound,
  subscriptionId,
  periodId,
  setIsLoading,
  setData,
  setButtons,
  setIsExpired,
  setActiveDateContent,
  setShowCalorieStatus,
  setTodayIndex,
  setActiveDate,
  showGuideModal,
  todayIndex,
  url = "",
  activeDateContent,
  setOpenModal,
}) {
  if (activeDateContent?.label !== "فستینگ") {
    setOpenModal(false);
    toast.success(" برای این روز فستینگی وجود ندارد", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

    return true;
  }
  const config = {
    headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
  };

  const body = {
    subscription_id: subscriptionId ?? null,
    period_id: periodId ?? null,
    day: activeDateContent?.day ?? null,
  };

  setIsLoading(true);
  setOpenModal(false);

  axios
    .post(`${APP_URL}${url}`, body, config)
    .then(function (response) {
      toast.success(response.data.elements.message ?? "", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsLoading(false);
      sync({
        handleNotfound,
        subscriptionId,
        periodId,
        setIsLoading,
        setData,
        setButtons,
        setIsExpired,
        setActiveDateContent,
        setShowCalorieStatus,
        setTodayIndex,
        setActiveDate,
        showGuideModal,
        todayIndex,
      });
    })
    .catch(function (error) {
      console.log(error);
      setIsLoading(false);

      if (!error.response) {
        handleNotfound();

        return false;
      }

      const statusCode = error.response.status;
      switch (statusCode) {
        case 422:
          const { errors } = error.response.data;

          for (const errorsKey in errors) {
            const error = errors[errorsKey];

            toast.error(error, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
          break;

        case 401:
          AuthService.logout();
          window.location.replace("/");
          break;
        default:
          handleNotfound();

          break;
      }
    });
}
